import { render } from "./VehicleimagesView.vue?vue&type=template&id=2e96f091"
import script from "./VehicleimagesView.vue?vue&type=script&lang=js"
export * from "./VehicleimagesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__